import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_114: FaireProductEntity = {
  token: "catalog_prod_prod-114",
  type: "product",
  name: "Stocking - Embroidered Santa's Sleigh (Pk/04)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 12.55,
  msrpDollars: 31.38,
  sku: "VI0114",
  caseSize: 6,
  material: "Cotton",
  collectionToken: "col_vintage-holiday",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 7,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
